/**
 * meeting.context.ts
 * Secured Communications
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

import { Meeting, WaitingDevice } from "../models/meeting";
import { SubscriberStream } from "../models/stream";

export interface HostControlsProvider {
  readonly isForceMuteAllActive: boolean,
  bootStream(stream: SubscriberStream): void,
  forceUnpublish(stream: SubscriberStream): void,
  forceMuteAudio(stream: SubscriberStream): Promise<void>,
  forceMuteAllButMe(): Promise<void>
}

export interface MeetingContext {
  readonly meeting: Meeting | null
  readonly muteNewStreams: boolean,
  setMeeting(meeting: Meeting | null): void,
  readonly waitingDevices: Array<WaitingDevice> | null,
  setWaitingDevices(devices: Array<WaitingDevice>): void,
  readonly streams: Array<SubscriberStream>,
  setStreams(streams: Array<SubscriberStream>): void,
  leaveMeeting(): void,
  toggleRightDetail(): void,
  toggleMembersView(): void,
  hostControlsProvider: HostControlsProvider | null,
  setHostControlsProvider(controller: HostControlsProvider | null): void,
  setMuteNewStreams(shouldMute: boolean): void
}

export const MeetingContext = React.createContext<MeetingContext>({
  meeting: null as Meeting | null,
  setMeeting: () => { },
  waitingDevices: null as Array<WaitingDevice> | null,
  setWaitingDevices: () => { },
  leaveMeeting: () => { },
  toggleRightDetail: () => { },
  toggleMembersView: () => { },
  streams: [],
  setStreams: () => { },
  hostControlsProvider: null,
  setHostControlsProvider: () => { },
  muteNewStreams: false,
  setMuteNewStreams: () => { }
});
